export default "__VITE_ASSET__bzWX$kTL__"